module.exports = __webpack_public_path__ + "img/7_155.6c38a581.png";